import React, { useEffect, useState } from 'react';

import { Row, Col, Card, CardHeader, CardBody } from 'reactstrap';
//flatpickr
import 'flatpickr/dist/themes/material_blue.css';
import 'flatpickr/dist/plugins/monthSelect/style.css';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import FlatPickr from 'react-flatpickr';
import Select from 'react-select';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { setBookingFilters } from 'store/actions';

const BookingFilters = props => {
	const [selectDate, setSelectDate] = useState();
	const [selectedFilterOptionsValues, setSelectedFilterOptionsValues] = useState();
	const [allFilterOptions, setAllFilterOptions] = useState([]);
	const dateChange = date => {
		setSelectDate(date);
	};

	const dispatch = useDispatch();

	useEffect(() => {
		if (props.bookingFilterData && props.bookingFilterData.length > 0) {
			setAllFilterOptions(props.bookingFilterData);
		}
	}, [props.bookingFilterData]);

	useEffect(() => {
		let selectedMonthValues =
			props.selectedFilters.findIndex(item => item.name === 'Month') > -1
				? new Date(props.selectedFilters.find(item => item.name === 'Month').value)
				: new Date();
		setSelectDate(selectedMonthValues.toDateString());
		setSelectedFilterOptionsValues([...props.selectedFilters]);
	}, [props.selectedFilters]);

	return (
		<React.Fragment>
			<Row className="blur mb-5">
				<Col xl={12}>
					<Card>
						<CardHeader>
							<h4 className="card-title mb-0">Advanced Filters</h4>
						</CardHeader>
						<CardBody>
							<Row>
								<Col xl={2}>
									<div className="me-2">
										<label htmlFor="date">Month</label>
										<div id="monthbookingfilter" className="w-100">
											<FlatPickr
												className="form-control mb-3 mb-xxl-0 w-100"
												name="selectedMonth"
												placeholder="Select time"
												options={{
													plugins: [
														new monthSelectPlugin({
															shorthand: true,
															dateFormat: 'M Y',
															altInput: true,
															altFormat: 'M Y',
															theme: 'light'
														})
													],
													static: true
												}}
												value={selectDate}
												onChange={date => {
													let selectedDate = moment(new Date(date[0])).format('MMMM YYYY');
													let selectedDatewithFormat = moment(new Date(date[0])).format('YYYY-MM');
													let previousSelectedValues = [...selectedFilterOptionsValues];
													let checkIndex = previousSelectedValues.findIndex(item => item.name === 'Month');
													if (checkIndex > -1) {
														previousSelectedValues[checkIndex] = {
															name: 'Month',
															value: selectedDatewithFormat,
															label: selectedDate,
															icon: null,
															canremove: false,
															fullValue: selectedDate,
															type: 'month'
														};
													}
													setSelectedFilterOptionsValues(previousSelectedValues);
												}}
											/>
										</div>
									</div>
								</Col>

								{allFilterOptions &&
									allFilterOptions.length > 0 &&
									allFilterOptions.map((outeritem, index) => {
										return outeritem.groupName != 'Booking Filters' ? (
											<Row className="mt-3 mb-2" key={'filterindex' + index + outeritem?.groupName}>
												<Col xl={12} className="mb-3">
													<div className="me-2">
														<h5>{outeritem?.groupName}</h5>
													</div>
												</Col>
												<Row>
													{outeritem?.data.map((item, index) => {
														let selectedValueForFilter =
															selectedFilterOptionsValues &&
															selectedFilterOptionsValues.length > 0 &&
															selectedFilterOptionsValues.find(sitem => sitem.name === item.filtername)?.fullValue;
														return (
															<Col xl={3} className="mb-3" key={'filterindex' + index}>
																<div className="me-2 flex-grow-1">
																	<label htmlFor="date">{item.filtername}</label>
																	<Select
																		className="mb-3 mb-xxl-0"
																		onChange={e => {
																			let previousSelectedValues = [...selectedFilterOptionsValues];
																			let checkIndex = previousSelectedValues.findIndex(
																				sitem => sitem.name === item.filtername
																			);
																			if (checkIndex > -1) {
																				previousSelectedValues[checkIndex] = {
																					name: item.filtername,
																					value: e.value,
																					label: e.label,
																					icon: e.icon,
																					canremove: true,
																					fullValue: e,
																					type: e.filterType
																				};
																			} else {
																				previousSelectedValues.push({
																					name: item.filtername,
																					value: e.value,
																					label: e.label,
																					icon: e.icon,
																					canremove: true,
																					fullValue: e,
																					type: e.filterType
																				});
																			}
																			setSelectedFilterOptionsValues(previousSelectedValues);
																		}}
																		id="filtervalues"
																		name="filtervalues"
																		value={selectedValueForFilter}
																		options={item.filtervalues.map(ele => ({
																			value: ele.filterid,
																			label: ele.filtervalue,
																			icon: ele.icon,
																			fullValue: ele,
																			filterType: item.filtertype
																		}))}
																	/>
																</div>
															</Col>
														);
													})}
												</Row>
											</Row>
										) : (
											outeritem?.data.map((item, index) => {
												let selectedValueForFilter =
													selectedFilterOptionsValues &&
													selectedFilterOptionsValues.length > 0 &&
													selectedFilterOptionsValues.find(sitem => sitem.name === item.filtername)?.fullValue;
												return (
													<Col xl={3} className="mb-3" key={'filterindex' + index}>
														<div className="me-2 flex-grow-1">
															<label htmlFor="date">{item.filtername}</label>
															<Select
																className="mb-3 mb-xxl-0"
																onChange={e => {
																	let previousSelectedValues = [...selectedFilterOptionsValues];
																	let checkIndex = previousSelectedValues.findIndex(
																		sitem => sitem.name === item.filtername
																	);
																	if (checkIndex > -1) {
																		previousSelectedValues[checkIndex] = {
																			name: item.filtername,
																			value: e.value,
																			label: e.label,
																			icon: e.icon,
																			canremove: true,
																			fullValue: e,
																			type: e.filterType
																		};
																	} else {
																		previousSelectedValues.push({
																			name: item.filtername,
																			value: e.value,
																			label: e.label,
																			icon: e.icon,
																			canremove: true,
																			fullValue: e,
																			type: e.filterType
																		});
																	}
																	setSelectedFilterOptionsValues(previousSelectedValues);
																}}
																id="filtervalues"
																name="filtervalues"
																value={selectedValueForFilter}
																options={item.filtervalues.map(ele => ({
																	value: ele.filterid,
																	label: ele.filtervalue,
																	icon: ele.icon,
																	fullValue: ele,
																	filterType: item.filtertype
																}))}
															/>
														</div>
													</Col>
												);
											})
										);
									})}

								{/* <div className="flex-grow-1">
                                    <div className="search-box">
                                        <div className="position-relative">
                                            <input type="text" className="form-control" placeholder="Search..." />
                                            <i className="bx bx-search-alt search-icon"></i>
                                        </div>
                                    </div>
                                </div> */}
								<div className="ms-2">
									<button
										type="button"
										onClick={() => {
											//props.setSelectedFilters([...selectedFilterOptionsValues]);
											dispatch(setBookingFilters([...selectedFilterOptionsValues]));
											props.setIsFilterModelOpen(false);
										}}
										className="btn btn-primary btn-sm waves-effect waves-light me-1 mt-3"
									>
										Search
									</button>
									<button
										type="button"
										onClick={() => {
											props.setIsFilterModelOpen(false);
										}}
										className="btn btn-secondary btn-sm waves-effect waves-light mt-3"
									>
										Cancel
									</button>
								</div>
							</Row>
						</CardBody>
					</Card>
				</Col>
			</Row>
		</React.Fragment>
	);
};

export default BookingFilters;
